import React from 'react';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import ReportsAppBase from '@atlassian/jira-spa-apps-servicedesk-reports-base/src/ui/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import KbRequestsReportsSpa from './ui';

const KbRequestsReportsApp = () => (
	<>
		<MarkProductStart />
		<ReportsAppBase
			pageId="reports-requests"
			appName={APP_NAMES.KB_REPORTS_REQUESTS}
			dontShowHeader={getWillShowNav4()}
		>
			{({ pageContext }) => <KbRequestsReportsSpa pageContext={pageContext} />}
		</ReportsAppBase>
	</>
);

export default KbRequestsReportsApp;
